@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner [accordian]="accordian" [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified" [isValid]="isValid" [hasPendingFunction]="hasPendingFunction" [slot]="slot"
      [(saveLabel)]="saveLabel" [isSaveEnable]="!isReadOnly"
      (save)="saveReplaceSecuritiesRebalance()" (cancel)="closeWithCheck()"><span header class="ms-header" tooltip [tooltipTitle]="rebalanceTitle" [tooltipRequiresTruncation]="true">{{rebalanceTitle}}</span></irb-editor-sidebar-banner>
      <div class="body" [style.height]="bodyHeight" #body>
        @if (data && !isUnitTest) {
          <rebalance-general-info [isReadOnly]="summarySource==='resultSummary'" [(data)]="data" (change)="onInputChange();" [ignoreUnsavedChanges]="ignoreUnsavedChanges"></rebalance-general-info>
        }
        <mat-accordion #accordian="matAccordion" [multi]="true">
          <mat-expansion-panel id="REBALANCE_SETTINGS" [expanded]="ies.getDefaultExpansionState('REBALANCE_SETTINGS')"
            (opened)="ies.updateExpansionState('REBALANCE_SETTINGS','opened')"
            (closed)="ies.updateExpansionState('REBALANCE_SETTINGS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Rebalance Settings
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data && !isUnitTest) {
                <irb-replace-securities-rebal-settings [isReadOnly]="isReadOnly" [(data)]="data"
                  (change)="onInputChange();">
                </irb-replace-securities-rebal-settings>
              }
            </ng-template>
          </mat-expansion-panel>
          @if (!isSchedulerRemove) {
            <mat-expansion-panel id="INCLUDED_PORTFOLIOS"
              [expanded]="ies.getDefaultExpansionState('INCLUDED_PORTFOLIOS')"
              (opened)="ies.updateExpansionState('INCLUDED_PORTFOLIOS','opened')"
              (closed)="ies.updateExpansionState('INCLUDED_PORTFOLIOS','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Included Portfolios
                  <span class="included-portfolios-panel-text"><span class="counter-text">{{getPortfolioCount()}}</span>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (!isUnitTest) {
                <included-portfolio #includedportfolio [data]="data" (dataChange)="onInputChange()">
                </included-portfolio>
              }
            </ng-template>
          </mat-expansion-panel>
        }
        @if (!isSchedulerRemove) {
          <mat-expansion-panel id="REBALANCE_SCHEDULER"
            [expanded]="ies.getDefaultExpansionState('REBALANCE_SCHEDULER')"
            (opened)="ies.updateExpansionState('REBALANCE_SCHEDULER','opened')"
            (closed)="ies.updateExpansionState('REBALANCE_SCHEDULER','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Schedule
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data && !isUnitTest) {
                <rebalance-scheduler [(data)]="data" [(scheduler)]="data.scheduler" (change)="onInputChange();"></rebalance-scheduler>
              }
            </ng-template>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
}
